<template>
  <div class="yfsy-wrap">
    <div class="yfsy-top">
      <div class="yfsy-left">
        <div class="yfsy-left-title">
          <span>消费汇总</span>
          <span>全部</span>
        </div>
        <div class="yfsy-left-container">
          <div class="yfsy-left-container-a">
            <div>帐项</div>
            <div>押金金额</div>
            <div>消费金额</div>
          </div>
          <div class="yfsy-left-container-b">
            <div>
              <div>帐项</div>
              <div>押金金额</div>
              <div>消费金额</div>
            </div>
            <div>
              <div>帐项</div>
              <div>押金金额</div>
              <div>消费金额</div>
            </div>
          </div>
        </div>
      </div>
      <div class="yfsy-right">
        <div class="yfsy-right-title">
          <span>消费明细</span>
        </div>
        <div class="yfsy-right-container">
          <div class="yfsy-right-container-a">
            <div>*</div>
            <div>账号</div>
            <div>房号</div>
            <div>项目名称</div>
            <div>金额</div>
            <div>说明</div>
            <div>利润点</div>
            <div>操作时间</div>
            <div>酒店时间</div>
            <div>操作员</div>
            <div>状态</div>
            <div>备注</div>
          </div>
          <div class="yfsy-right-container-b">
            <div class="checked">
              <div>*</div>
              <div>账号</div>
              <div>房号</div>
              <div>项目名称</div>
              <div>金额</div>
              <div>说明</div>
              <div>利润点</div>
              <div>操作时间</div>
              <div>酒店时间</div>
              <div>操作员</div>
              <div>状态</div>
              <div>备注</div>
            </div>
            <div>
              <div>*</div>
              <div>账号</div>
              <div>房号</div>
              <div>项目名称</div>
              <div>金额</div>
              <div>说明</div>
              <div>利润点</div>
              <div>操作时间</div>
              <div>酒店时间</div>
              <div>操作员</div>
              <div>状态</div>
              <div>备注</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="yfsy-foot">
      <div>收款</div>
      <div>消费</div>
      <div>房帐处理</div>
      <div>调整</div>
      <div>账单</div>
      <div>结账</div>
      <div>取消结账</div>
      <div>打印</div>
      <div>导出</div>
    </div>
  </div>
</template>

<script>
// vue是对数据的编程，所以做啥都跟数据有关
import { getRequest } from "@/api/api1.js";
export default {
  data() {
    return {
      //clickIndex1: null,
      list: [] //我们的数据
      // doadd: false,
      // doupdate: false,
      // dodelete: false
    };
  },
  computed: {
    // titleIndex() {
    //   return this.$store.state.operationIndex;          //点击事件：点击发生了什么——>按钮用这个统一样式
    // },
    // ckIndex() {
    //   return this.$store.state.tCustomerLinkIndex;      //一行数据点击之后用这个统一样式
    // },
  },
  created() {
    //这一条数据的生命周期
    this.checkPower(); //验证权限，有没有权限做这些事，如果有就继续，方法里面有权限的获取
    // if (this.$store.state.tCustomerLink.length > 0) {    //一整条数据是否存在
    //   this.list = this.$store.state.tCustomerLink;       //list数组里面就是这一条数据的内容
    // } else {
    //   let loadingInstance = this.$loading({text: "加载中",});    //如果这数据不存在，则要去接口请求数据
    //   getRequest("/tCustomerLink/selectAll?hotelId=" + localStorage.getItem("ihotelid")).then((res) => {
    //     this.$nextTick(() => {loadingInstance.close()});     //不回调
    //     if (res.status == 200) {
    //       this.list = res.data;      //加载成功的话，这条数据就赋给list
    //       this.$store.state.tCustomerLink = res.data;     //这一条数据已经显示在页面上了
    //     } else {
    //       this.$mymessage({content: res.message,type: "error",time: 3000,hasClose: true,});    //如果无法获取这一条数据，就报错
    //     }
    //   });
    // }
  },
  methods: {
    checkPower() {
      //获取权限码
      if (!this.power.checkedpower("0106000")) {
        //查看   //在PMS管理系统里面-获取权限
        this.$router.push("/power");
      }
      this.doadd = this.power.checkedpower("0106001"); //消费
      this.doupdate = this.power.checkedpower("0106002"); //冲账
      this.dodelete = this.power.checkedpower("0106004"); //打印
      this.dodaochu = this.power.checkedpower("0106005"); //导出
    },
    operation(index) {
      // if (index == 0) {  //index為0，就是創建，前面有寫
      //   this.$store.state.operationIndex = index;     //要在store裡面定义变量
      //   this.showbox({ operation: "创建" });    //窗口的定义，后面引用operation为创建
      // } else if (index == 1) {   //index为1，就是修改
      //   if (this.ckIndex != null) {    //修改需要判断，是否选中要修改的数据，如果有就继续
      //     let obj = JSON.parse( JSON.stringify(this.$store.state.tCustomerLink[this.ckIndex]));  //如果选中了要修改的数据，那么就要先提取出来，以便后面操作修改
      //     obj.operation = "修改";
      //     obj.tCustomerLinkIndex = this.ckIndex;   //这个点击选中的一行要修改的数据，赋值给在store里面定义的对象
      //     this.$store.state.operationIndex = index;
      //     this.showbox(obj);
      //   } else {
      //     this.$mymessage({ content: "请选择修改内容",type: "error",time: 2000,hasClose: true});
      //     return;
      //   }
      // } else if (index == 2) {
      //   if (this.ckIndex != null) {
      //     let obj = JSON.parse(JSON.stringify(this.$store.state.tCustomerLink[this.ckIndex]));
      //     obj.title = "删除";
      //     obj.message = "您确定要删除吗";
      //     obj.tCustomerLinkIndex = this.ckIndex;
      //     this.$store.state.operationIndex = index;
      //     this.$confirm({ obj });
      //   } else {
      //     this.$mymessage({content: "请选择删除内容",type: "error",time: 2000,hasClose: true});
      //   }
      // }
    },
    showbox(obj) {
      //this.$LianXiRen({ obj });
    },
    chooseIndex(index) {
      //this.$store.state.tCustomerLinkIndex = index;
    }
  }
};
</script>

<style scoped>
.yfsy-wrap {
  width: 94%;
  height: 94%;
  margin: 3%;
}
.yfsy-top {
  height: 88%;
  display: flex;
}
.yfsy-left {
  width: 20%;
  height: 98%;
  box-shadow: 5px 5px 9px #a0bdee, -5px -5px 9px white;
  border-radius: 0.8em;
  margin-right: 2%;
  display: flex;
  flex-direction: column;
}
.yfsy-left-title {
  height: 7.5%;
  border-radius: 0.8em 0.8em 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1.2em;
  font-size: 0.8em;
  color: #2c3036;
}
.yfsy-left-title span:nth-child(2) {
  color: #1471fe;
}
.yfsy-left-container {
  flex: 1;
  box-shadow: 3px 3px 6px #a0bdee inset, -3px -3px 6px white inset;
  border-radius: 0 0 0.8em 0.8em;
  display: flex;
  flex-direction: column;
  position: relative;
}
.yfsy-left-container-a {
  display: flex;
  align-items: center;
  line-height: 2em;
  font-size: 0.7em;
  box-shadow: 0px 1px 2px rgb(161, 161, 161);
  margin-top: 0.5em;
}
.yfsy-left-container-a > div {
  text-align: center;
  flex: 1;
}

.yfsy-left-container-b {
  flex: 1;
  overflow: auto;
}
/* .yfsy-left-container::after {
  content: "";
  position: absolute;
  width: 2px;
  height: 99%;
  top: 1%;
  right: 33.3%;
  border-right: 2px solid rgb(245, 244, 244);
} */
.yfsy-left-container-b > div {
  display: flex;
  align-items: center;
  line-height: 2em;
  font-size: 0.7em;
  margin-top: 0.5em;
  box-shadow: 0px 1px 1px rgb(202, 202, 202);
}
.yfsy-left-container-b > div:last-child {
  box-shadow: none;
}
.yfsy-left-container-b > div div {
  text-align: center;
  flex: 1;
}

.yfsy-right {
  width: 78%;
  height: 98%;
  box-shadow: 5px 5px 9px #a0bdee, -5px -5px 9px white;
  border-radius: 0.8em;
  display: flex;
  flex-direction: column;
}
.yfsy-right-title {
  height: 7.5%;
  border-radius: 0.8em 0.8em 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1.2em;
  font-size: 0.8em;
  color: #2c3036;
}
.yfsy-right-container {
  flex: 1;
  box-shadow: 3px 3px 6px #a0bdee inset, -3px -3px 6px white inset;
  border-radius: 0 0 0.8em 0.8em;
  display: flex;
  flex-direction: column;
  position: relative;
}
.yfsy-right-container-a {
  display: flex;
  align-items: center;
  line-height: 2em;
  font-size: 0.7em;
  margin-top: 0.5em;
}
.yfsy-right-container-a > div {
  text-align: center;
  flex: 1;
}

.yfsy-right-container-b {
  flex: 1;
  overflow: auto;
}

.yfsy-right-container-b .checked{
  background: rgb(179,222,254);
  color:#1471FE
}
.yfsy-right-container-b .checked div{
  position: relative;
}
.yfsy-right-container-b .checked div::after{
  position: absolute;
  content: '';
  width: 1px;
  height: 60%;
  top:20%;
  right:0;
  border-right: 1px solid #1471FE;
}
.yfsy-right-container-b .checked div:last-child:after{
  border:none
}
.yfsy-right-container-b > div {
  display: flex;
  align-items: center;
  line-height: 2em;
  font-size: 0.7em;
  margin-top: 0.5em;
}
.yfsy-right-container-b > div div {
  text-align: center;
  flex: 1;
}
.yfsy-foot {
  height: 10%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.yfsy-foot > div {
  font-size: 0.9em;
  color: #1471fe;
  box-shadow: 3px 3px 4px #a0bdee, -3px -3px 4px white;
  border-radius: 0.5em;
  padding: 0.7em 1.2em;
  margin-right: 1.2em;
  cursor: pointer;
}
.yfsy-foot > div:hover{
  transform: scale(1.2);
}
</style>